import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header className="header">
            <h1>OliveiraDevs</h1>
            <nav>
                <Link to="/">Home</Link>
                <Link to="/about">Sobre</Link>
                <Link to="/services">Serviços</Link>
                <Link to="/contact">Contato</Link>
            </nav>
        </header>
    );
};

export default Header;